module.exports = __webpack_public_path__ + "img/me_example.f5a08456.jpg";